module.exports = "<div class=\"row\">\n  <div class=\"col-sm-5\">\n    <app-recipe-list></app-recipe-list>\n  </div>\n  <div class=\"col-sm-7\">\n    <app-recipe-detail></app-recipe-detail>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/recipes/recipes.component.html
// module id = 159
// module chunks = 1